import { Flex } from "@mantine/core";
import { useState } from "react";
import { AccordionDescriptions } from "../../../components";
import PerformanceChart from "./PerformanceChart";

export default function Performance() {
  const [accordionValue, setAccordionValue] = useState<string[]>([
    "GraphicPerformance",
    "GeneralStatistics",
  ]);
  return (
    <Flex
      justify="space-between"
      align="center"
      bg="basic.0"
      p={{ base: "12px", 991: 32 }}
      direction={"column"}
      gap="24px"
      wrap={{ base: "wrap", 1650: "nowrap" }}
      sx={{ borderRadius: "12px 12px 0 0" }}
    >
      <Flex
        w="100%"
        gap={24}
        direction={{ base: "column", 1700: "column" }}
        justify={"space-between"}
        align={"start"}
      >
        <Flex
          w="100%"
          gap={24}
          direction={{ base: "column", 780: "row" }}
          justify={"space-between"}
          align={"start"}
        >
          <AccordionDescriptions
            accordionValue={accordionValue}
            setAccordionValue={setAccordionValue}
          >
            <PerformanceChart />
          </AccordionDescriptions>
        </Flex>
      </Flex>
    </Flex>
  );
}
